import { Grid } from '@material-ui/core';
import React from 'react';
import { useSubscriptionPlans } from 'v2/hooks/useSubscriptionPlan';

import type { SubscriptionPlan as Plan } from 'v2/interfaces/product';

import { ActionsMenu } from './ActionMenu';
import { ListSubscriptionPlans } from './ListSubscription';
import { ComissionModal } from './ListSubscription/ComissionModal';
import { FormContent } from '../../FormContent';

import type IProduct from 'interfaces/IProduct';

type ListSubscriptionPlan = {
  product: IProduct;
  updateProduct: (product: IProduct) => void;
  loading: boolean;
};

export const SubscriptionPlans = ({ product, updateProduct, loading }: ListSubscriptionPlan) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = React.useState<Plan>(null);

  const { isLoading, data, isError } = useSubscriptionPlans(product.id, {
    enabled: !!product.id,
  });

  const handleActionsClick = React.useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>, plan: Plan) => {
    setAnchorEl(event.currentTarget);
    setSubscriptionPlan(plan);
  }, []);

  function handleOpenModal() {
    setOpenModal(true);
    setAnchorEl(null);
  }

  function handleCloseModal() {
    setOpenModal(false);
    setSubscriptionPlan(null);
  }

  return (
    <Grid container item xs={12}>
      <FormContent title='Comissões' loading={loading}>
        <p>Habilite as comissões para cada plano existente desse produto.</p>

        <ListSubscriptionPlans plans={data} isLoading={isLoading} isError={isError} handleActionsClick={handleActionsClick} />
      </FormContent>
      <ActionsMenu anchorEl={anchorEl} closeMenu={() => setAnchorEl(null)} handleModal={handleOpenModal} />

      {!!subscriptionPlan && (
        <ComissionModal
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          planId={subscriptionPlan.plan_id}
          product={product}
          membershipFee={subscriptionPlan?.membership_fee}
          updateProduct={updateProduct}
        />
      )}
    </Grid>
  );
};
